import type {ILabel} from '../types'

export const onInput = (property: { value: string, invalidLabel: ILabel|null, hidden?: boolean }) => {
    if(property.invalidLabel && property.value !== '') {
        property.invalidLabel = null
    }
}